module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('app-draw-feature', {
    ref: "draw",
    attrs: {
      "map": _vm.map,
      "mode": _vm.drawMode,
      "active": _vm.isActive,
      "drawing": _vm.isDrawActive
    },
    on: {
      "drawend": _vm.onDrawEnd
    }
  }), _vm._v(" "), _c('app-raster-legend', {
    ref: "legend",
    staticClass: "app-raster-legend",
    staticStyle: {
      "position": "absolute",
      "bottom": "15px",
      "margin-left": "15px",
      "z-index": "1"
    },
    attrs: {
      "value": _vm.isActive && !_vm.isDynamicStyle,
      "layout": "vertical"
    }
  }), _vm._v(" "), _c('v-navigation-drawer', {
    ref: "nav",
    attrs: {
      "app": "",
      "disable-resize-watcher": "",
      "hide-overlay": "",
      "mobile-break-point": "0",
      "value": _vm.isActive,
      "width": "500"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Ratios")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('disableControl')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": ("grey " + (_vm.$store.getters.isDarkTheme ? 'darken-4' : 'lighten-4')),
      "height": "64"
    }
  }, [_c('div', {
    staticClass: "container-buttons"
  }, [_c('v-tooltip', {
    staticStyle: {
      "align-self": "center"
    },
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "disabled": _vm.disabledButtons,
      "fab": "",
      "small": "",
      "color": "green darken-2"
    },
    on: {
      "click": _vm.repeatSearch
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("youtube_searched_for")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('_busquedas.nueva')))])], 1), _vm._v(" "), _c('v-tooltip', {
    staticStyle: {
      "align-self": "center"
    },
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "disabled": _vm.disabledButtons,
      "fab": "",
      "small": "",
      "color": "green darken-2"
    },
    on: {
      "click": function($event) {
        _vm.showBufferDialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("open_with")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('_busquedas.buffer')))])], 1)], 1)])], 1), _vm._v(" "), _c('app-select-draw-mode', {
    ref: "drawModeSelector",
    attrs: {
      "poligono": "",
      "rectangulo": "",
      "defaultMode": "Polygon"
    },
    on: {
      "change-draw-mode": _vm.onDrawModeChange
    }
  }), _vm._v(" "), _c('v-scale-transition', [_c('v-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDrawActive),
      expression: "isDrawActive"
    }],
    staticClass: "mt-0",
    attrs: {
      "type": "info",
      "color": _vm.$store.getters.isDarkTheme ? 'green darken-2' : 'green lighten-2'
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t(_vm.drawMode == _vm.geometryModes.POINT ? 'dibuja.punto' : 'dibuja.poligono')) + "\n      ")])], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-toolbar', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "color": ("green " + (_vm.$store.getters.isDarkTheme ? 'darken-2' : 'lighten-2'))
    },
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('opciones')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.collapsed ? 'add' : 'remove'))])], 1)], 1)], 1), _vm._v(" "), (_vm.collapsed && _vm.isDynamicStyle) ? _c('v-divider', {
    attrs: {
      "dark": _vm.$store.getters.isDrakTheme
    }
  }) : _vm._e(), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-slide-y-transition', [_c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "px-3 pb-3",
    attrs: {
      "color": _vm.$store.getters.isDarkTheme ? 'grey darken-4' : 'grey lighten-4'
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('app-select-indicador', {
    attrs: {
      "disabled": true
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('app-select-period', {
    attrs: {
      "disabled": _vm.disabledButtonsByDialogs || (_vm.isDrawActive && !!_vm.result)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('app-select-ortofotos', {
    attrs: {
      "map": _vm.map,
      "ortoLayer": _vm.LayerOrto,
      "disabled": _vm.disabledButtonsByDialogs || (_vm.isDrawActive && !!_vm.result)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('app-select-raster', {
    ref: "rasterselect",
    attrs: {
      "value": _vm.isActive,
      "disabled": _vm.disabledButtonsByDialogs || (_vm.isDrawActive && !!_vm.result)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('app-select-saved-polygon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.drawMode == _vm.geometryModes.POLYGON || _vm.drawMode == _vm.geometryModes.CIRCLE),
      expression: "drawMode == geometryModes.POLYGON || drawMode == geometryModes.CIRCLE"
    }],
    ref: "selectSavedPolygon",
    attrs: {
      "map": _vm.map,
      "disabled": _vm.isLoading || _vm.showBufferDialog
    },
    on: {
      "selected": _vm.onSelectedSavedPolygon
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('app-buffer-feature', {
    attrs: {
      "feature": _vm.lastFeature,
      "map": _vm.map,
      "value": _vm.showBufferDialog
    },
    on: {
      "selected": _vm.onBufferSelected,
      "cancel": function($event) {
        _vm.showBufferDialog = false
      }
    }
  }), _vm._v(" "), _c('v-divider', {
    attrs: {
      "dark": _vm.$store.getters.isDrakTheme
    }
  }), _vm._v(" "), _c('v-scale-transition', [_c('v-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.result),
      expression: "!!result"
    }],
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "justify-content": "space-around"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "140",
      "flat": "",
      "ripple": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('v-card-actions', [_c('v-btn', {
    staticStyle: {
      "margin": "0px auto"
    },
    attrs: {
      "color": "primary",
      "icon": ""
    }
  }, [_c('vector-polygon-icon', {
    staticStyle: {
      "font-size": "24px"
    }
  })], 1)], 1), _vm._v(" "), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedArea)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('area-poligono')))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "140",
      "flat": "",
      "ripple": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('v-card-actions', [_c('v-btn', {
    staticStyle: {
      "margin": "0px auto"
    },
    attrs: {
      "color": "primary",
      "icon": "",
      "ripple": false
    }
  }, [_c('v-icon', [_vm._v("people")])], 1)], 1), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.population || 0) + " hab.")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('poblacion-afectada')))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "140",
      "flat": "",
      "ripple": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('v-card-actions', [_c('v-btn', {
    staticStyle: {
      "margin": "0px auto"
    },
    attrs: {
      "color": "primary",
      "icon": "",
      "ripple": false
    }
  }, [_c('v-icon', [_vm._v("nature")])], 1)], 1), _vm._v(" "), _c('h2', [_vm._v(_vm._s(Math.round(_vm.greenSurface)) + " m"), _c('sup', [_vm._v("2")])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('ratios.superficie_zona_verde')))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "140",
      "flat": "",
      "ripple": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('v-card-actions', [_c('v-btn', {
    staticStyle: {
      "margin": "0px auto"
    },
    attrs: {
      "color": "primary",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("nature_people")])], 1)], 1), _vm._v(" "), _c('h2', [_vm._v(_vm._s(Math.round(_vm.greenSurface / _vm.population)) + " m"), _c('sup', [_vm._v("2")]), _vm._v("/hab.")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('ratios.superficie_zona_verde_por_hab')))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "140",
      "flat": "",
      "ripple": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('v-card-actions', [_c('v-btn', {
    staticStyle: {
      "margin": "0px auto"
    },
    attrs: {
      "color": "primary",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("nature")])], 1)], 1), _vm._v(" "), _c('h2', [_vm._v(_vm._s((_vm.greenSurface * 100 / _vm.affectedArea).toFixed(2)) + " %")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('ratios.porcentaje_superficie_zona_verde')))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "140",
      "flat": "",
      "ripple": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('v-card-actions', [_c('v-btn', {
    staticStyle: {
      "margin": "0px auto"
    },
    attrs: {
      "color": "primary",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("flare")])], 1)], 1), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.absorcion))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('ratios.absorcion')) + " TnCO"), _c('sub', [_vm._v("2")]), _vm._v(" / Ha - " + _vm._s(_vm.$t(("ratios.periods." + (_vm.period.toLowerCase())))))])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ef68282","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/vegetacion/Ratios.vue
// module id = 1073
// module chunks = 1